import React, { useMemo } from "react";
import { RouteComponentProps } from "react-router";

import CampaignForm from "../components/campaigns/CampaignForm";
import useViewer from "../hooks/useViewer";

type EditCampaignProps = RouteComponentProps<{ id: string }>;

const EditCampaign: React.FC<EditCampaignProps> = ({
  match,
}) => {
  const {
    company: { id: companyId, campaigns },
  } = useViewer();

  const campaign = useMemo(
    () => campaigns.find((host) => host.slug === match.params.id),
    []
  );

  return (
    <CampaignForm
      defaultValues={{
        id: campaign.id,
        companyId,
        reminderEnabled: campaign.reminderEnabled.toString(),
        reminderGap: campaign.reminderGap,
        name: campaign.name as string,
        description: campaign.description as string,
      }}
    />
  );
};

export default React.memo(EditCampaign);
